import { h } from 'preact';
import PropTypes from 'prop-types';

import { getClassNames } from '../../../../utils/classnames-utils';

import { selectModifiersList } from './prop-list';

const DEFAULT_IS_ACTIVE = false;

const Select = ({ isActive = DEFAULT_IS_ACTIVE, modifiers, noPointerEvents, onClick }) => {
  let classNames = getClassNames('c-select', modifiers);
  if (isActive) {
    classNames += ' is-active';
  }
  if (noPointerEvents) {
    classNames += ' no-pointer-events';
  }
  return (
    <button className={classNames} type="button" onClick={onClick}>
      <div className="c-select__dot" />
      <div className="c-select__dot" />
      <div className="c-select__dot" />
    </button>
  );
};

Select.propTypes = {
  isActive: PropTypes.bool,
  modifiers: PropTypes.arrayOf(PropTypes.oneOf(selectModifiersList)).isRequired,
  noPointerEvents: PropTypes.bool,
  onClick: PropTypes.func,
};

export default Select;
